import { useEffect, useState } from "react";
import { URLApi } from "../../../services/api_function";  // Assuming this is your API
import toast from "react-hot-toast";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import { RiFileExcel2Line } from "react-icons/ri";
import { CSVLink } from "react-csv";
import moment from "moment";


function WithdarwReport() {
    const [selectedDate, setSelectedDate] = useState(null);
    const [tableData, setTableData] = useState([])
    const [fullcsvData, setfullcsvData] = useState([]);
    const [selectedDates, setSelectedDates] = useState([null, null]);
    const [open, setOpen] = useState(false);
    useEffect(() => {
        if (selectedDate) {
            const fetchData = async () => {
                const userDetails = localStorage.getItem("adminToken");
                const token = userDetails;
                try {
                    const formattedFromDate = selectedDates[0].toISOString();
                    const formattedToDate = selectedDates[1].toISOString();

                    const response = await axios.get(URLApi + `/withdraw-report`, {
                        params: {
                            fromDate: formattedFromDate,
                            toDate: formattedToDate,
                        },
                        headers: {
                            "Authorization": `Bearer ${token}`,
                        },
                    });
                    console.log(response, "response")
                    setTableData(response?.data?.userData)

                    if (response.data) {
                        const ModifiedData = response.data.userData.map((item) => {
                            const { user, name, usdtAmount, mether_amount, mwther_rate, wallet_type, payment_method, trxnHash, createdAt } = item;
                            const Timestamp = moment(createdAt).format("DD-MM-YYYY HH:mm");


                            return {
                                user, name, usdtAmount, mether_amount, mwther_rate, wallet_type, payment_method, trxnHash,
                                createdAt: Timestamp,
                            };
                        });
                        setfullcsvData(ModifiedData);
                    }
                } catch (error) {
                    toast.error("Failed to fetch data.", error);
                    console.log(error, "erroe")
                }
            };
            fetchData();
        } else {
            setTableData([]);
            setfullcsvData([]);  // Reset CSV data when no date is selected
        }
    }, [selectedDate]);
    const columns = [
        { label: "Name", key: "name" },
        { label: "User", key: "user" },
        { label: "UsdtAmount", key: "usdtAmount" },
        { label: "MetherAmount", key: "mether_amount" },
        { label: "MetherPrice", key: "mwther_rate" },
        { label: "Type", key: "wallet_type" },
        { label: "Payment Method", key: "payment_method" },
        { label: "Transaction Hash", key: "trxnHash" },
        { label: "Date&Time", key: "createdAt" },
    ];


    const handleDateChange = (dates) => {
        setSelectedDates(dates); // Set both from and to dates

        // If both dates are selected, close the calendar
        if (dates[0] && dates[1]) {
            setOpen(false); // Close calendar after selecting both dates
            setSelectedDate(dates[0]); // Set the 'From' date (you can use this to fetch data if needed)
        }
    };
    return (
        <div
            className="d-flex justify-content-center align-items-center bg-primary bg-gradient"
        >
            <div
                className="bg-white shadow-lg rounded-4 p-4 w-100"
                style={{
                    maxWidth: "12000px",
                    width: "100%",
                    height: "auto",
                    overflowY: "auto",
                }}
            >
                <h2 className="text-center fw-bold text-dark mb-4">Select Date</h2>


                <div className="d-flex justify-content-between align-items-center mb-4">
                    <div className="d-flex flex-column align-items-start">
                        <label htmlFor="selectDate" className="form-label fw-semibold text-dark mb-2">
                            Choose Date
                        </label>
                        <DatePicker
                            selected={selectedDates[0]} // fromDate
                            onChange={handleDateChange} // Set both dates
                            startDate={selectedDates[0]} // fromDate
                            endDate={selectedDates[1]} // toDate
                            selectsRange
                            inline
                            dateFormat="dd/MM/yyyy"
                            placeholderText="Select a date range"
                            open={open}
                            onCalendarClose={() => setOpen(false)} // Ensure it closes when clicking outside
                            onCalendarOpen={() => setOpen(true)} // Open the calendar when clicking on input
                        />
                    </div>
                    <CSVLink
                        data={fullcsvData} // Add your actual data here
                        headers={columns} // Add your headers here
                        filename={"Withdraw.csv"}
                        style={{
                            color: "black",
                            padding: "10px 20px",
                            textDecoration: "none",
                            borderRadius: "5px",
                            border: "1px solid black",
                            fontWeight: "bold",
                            marginLeft: "20px",
                        }}
                    >
                        <RiFileExcel2Line />
                        Export to CSV
                    </CSVLink>


                </div>
                {/* </div> */}
                {/* Table Section */}
                <h3 className="text-center text-dark mb-4">Withdraw Data</h3>
                <div className="table-responsive">
                    <table className="table table-bordered table-striped table-hover">
                        <thead className="thead-dark">
                            <tr>
                                <th>S.No</th>
                                <th>Name</th>
                                <th>User</th>
                                <th>Usdt Amount</th>
                                <th>Mether Amount</th>
                                <th>Type</th>
                                <th>Method</th>
                                <th>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableData?.length > 0 ? (
                                tableData.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item?.name}</td>
                                        <td>{item?.user}</td>
                                        <td>
                                            {Number(item?.usdtAmount).toFixed(2)}
                                        </td>
                                        <td>
                                            {Number(item?.mether_amount).toFixed(2)}
                                        </td>
                                        <td>
                                            {(item?.wallet_type)}
                                        </td>
                                        <td>{item?.payment_method}</td>
                                        <td>{new Date(item.createdAt).toLocaleDateString('en-GB')}</td>

                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" className="text-center">
                                        No data available for the selected date.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default WithdarwReport;
